import { useLocation } from 'react-router-dom';
import React from 'react';
import SearchResultsPage from './SearchResultsPage';

export default function SearchResultsPageWrapper() {
    const location = useLocation();

    return (
        <React.Fragment>
            <SearchResultsPage key={location.key} />
        </React.Fragment>
    );
}
